import { styled } from '@mui/material/styles';

import { Button as SharedButton } from 'shared/components/buttons/Button';

export const Button = styled(SharedButton)(({ theme }) => ({
  gap: theme.spacing(1),
  width: '100%',
  borderRadius: '24px',
}));
